import React, { useState } from "react";
import CircularProgress from "@material-ui/core/CircularProgress";
import PrimaryActionButton from "../../Shared/PrimaryActionButton/PrimaryActionButton";
import Dialog from "@material-ui/core/Dialog";
import FileUploader from "./FileUploader";
import axios from "axios";
import { toast } from "react-toastify";
import DownloadIcon from "../../ServiceReferral/icons/download.svg";
import SecondaryActionButton from "../../Shared/SecondaryActionButton/SecondaryActionButton";

export default function LatestCallReportDownload() {
  const [loading, setLoading] = useState(false);
  const [open, setOpen] = useState(false);
  const [errors, setErrors] = useState({});
  const downloadReport = () => {
    setLoading(true);
    setTimeout(() => {
      setLoading(false);
    }, 3000);
  };

  const UploadFile = (file) => {
    const formBody = new FormData();
    formBody.append("file", file);

    setLoading(true);
    setErrors({});

    axios
      .post(
        `${process.env.REACT_APP_API_URL}/api/reports/v3/last-n-call-report`,
        formBody,
        {
          headers: {
            Authorization:
              "Bearer " + JSON.parse(localStorage.getItem("currUserToken")),
          },
          responseType: "blob",
        }
      )
      .then((response) => {
        toast.success("File uploaded successfully");
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute(
          "download",
          `_UPLOADED_Last_N_Call_Viewer_Report.csv`
        );
        document.body.appendChild(link);
        link.click();
        link.remove();
        setLoading(false);

        // handleClose();
      })
      .catch((err) => {
        setLoading(false);

        // Handle different error scenarios
        if (err.response) {
          // Server responded with an error status code
          const { status, data } = err.response;

          if (status === 400 && data.errors) {
            // Validation errors
            const fieldErrors = {};
            Object.entries(data.errors).forEach(([field, message]) => {
              fieldErrors[field] = message;
            });
            setErrors(fieldErrors);
            toast.error("Please fix the form errors");
          } else if (status === 401 || status === 403) {
            // Authentication/Authorization errors
            toast.error("You don't have permission to upload files");
            setTimeout(() => {
              // Redirect to login if session expired
              window.location.href = "/signin";
            }, 2000);
          } else if (status === 413) {
            // File too large
            toast.error("The uploaded file is too large");
          } else {
            // Other server errors
            const errorMessage = data.message || "Failed to upload file";
            toast.error(errorMessage);
          }
        } else if (err.request) {
          // Request made but no response received (network error)
          toast.error(
            "Network error. Please check your connection and try again"
          );
        } else {
          // Error in setting up the request
          toast.error("An unexpected error occurred");
        }

        console.error("File upload Error:", err);
      });
  };

  return (
    <>
      <SecondaryActionButton
        title="Latest Call report download"
        onClick={() => setOpen(true)}
        loading={loading}
        style={{
          background: "#FFEFF6",
          color: "#E2136E",
          width: "fit-content",
          borderRadius: 8,
        }}
      />
      <Dialog
        open={open}
        onClose={() => setOpen(false)}
        maxWidth="sm"
        fullWidth
      >
        <div
          style={{
            padding: 30,
            display: "flex",
            flexDirection: "column",
            gap: 20,
            justifyContent: "center",
          }}
        >
          <h5
            style={{
              margin: 0,
              fontSize: 20,
              fontFamily: "Inter",
              color: "#362B73",
            }}
          >
            Latest call report download
          </h5>
          <FileUploader
            onFileUpload={(file) => {
              UploadFile(file);
            }}
          />
          {loading && (
            <span
              style={{
                display: "flex",
                gap: 10,
                color: "#f53689",
                paddingBottom: 20,
                justifyContent: "center",
              }}
            >
              <CircularProgress size={20} color="inherit" />
              Processing, Please wait !
            </span>
          )}
        </div>
      </Dialog>
    </>
  );
}
